(function (window, $) {
    if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
    }

    window.SwymCallbacks.push(function () {
        _swat.fetchWrtEventTypeET(function (products) {
            wishlistRender(products);
            setMinHeight();

            var shareButton = $('[data-action="toggle-social-share"]');
            var shareSocialButton = $('.Product__ActionItem').find('.Product__ShareItem');
            var shareSocialLink = $('.Product__ActionItem').find('.Product__ShareEmailItem');

            openShareWishlist(shareButton);
            shareSocialButton.each(function () {
                wishlistShare($(this));
            });

            // share link
            var shareLinkButton = $('.Product__ActionItem').find('.Product__ShareLinkItem');
            shareLinkButton.each(function () {
                wishlistShareLink($(this));
            });

            //  share email
            if ($(shareSocialLink).length > 0) {
                shareSocialLink.each(function () {
                    generateShareLink($(this));
                });
            }


            var bouncing;
            $(window).on('resize', function () {
                clearInterval(bouncing);
                bouncing = setTimeout(function () {
                    setMinHeight();
                }, 200);
            });
        }, _swat.EventTypes.addToWishlist);
    });
    window.SwymCallbacks.push(function () {
        $('body').trigger('wishlist:ready');
    });

    async function wishlistGetProduct(handleProduct) {
        const product = await $.getJSON(handleProduct + '.js');
        return product;
    }

    async function wishlistRenderTag(product, ending) {
        const tags = product.tags;
        const labelTags = tags.filter(tag => tag.startsWith(ending));

        if (labelTags.length > 0) {
            return labelTags[0].split(ending)[1];
        }
    }


    openShareWishlist = function (shareButton) {
        shareButton.on('click', function () {
            $(this).toggleClass('is-active');
            $(this).toggleClass('RoundButton--secondaryState');

            $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
            $(this).next().attr('aria-hidden', $(this).next().attr('aria-hidden') === 'true' ? 'false' : 'true');
        })
    };
    wishlistShare = function (shareSocialButton) {
        let lid = null; // List ID you wish to share.
        let fromName = shareSocialButton.parent('.Product__ShareList-wishlist').attr('data-sharer');
        let platformShareUrlTemplate = shareSocialButton.attr('data-share-url'); // this is specific to platform, please look up your platform.
        let platform = shareSocialButton.attr('data-platform') // name of the platform
        let onError = function (error) {
            // Error is an xhrObject
            console.log("There was an Error opening the share platform", error);
        }
        shareSocialButton.on('click', function (e) {
            _swat.shareListSocial(lid, fromName, platformShareUrlTemplate, platform, '', onError);
        })

    };


    wishlistRender = function (products) {
        $(function () {
            var template = $('[data-wishlist-template]');
            var empty_template = $('[data-wishlist-empty]');
            var $wishlistContainer = $('#wishlist-content');

            var startLoading = function ($context) {
                if ($context) {
                    $context.addClass('loading');
                } else {
                    $wishlistContainer.addClass('loading');
                }
            }

            var stopLoading = function ($context) {
                if ($context) {
                    $context.removeClass('loading');
                } else {
                    $wishlistContainer.removeClass('loading');
                }
            }

            if (!products || products.length < 1) {
                empty_template.show();
                return;
            }

            let products_remaining = products.length;

            products.forEach(async function (p) {
                var row = template.clone();

                row.removeClass('hidden');
                row.find('[data-name]').html(p.dt.split('-')[0]);
                let product;

                if (p.du) {
                    product = await wishlistGetProduct(p.du);
                    const vendor = await wishlistRenderTag(product, 'pfs:label-');
                    row.find('[data-vendor]').html(vendor);

                    // add variant to wishlist quickbuy form
                    const quickBuySizesContainer = row.find('.quickbuy__form .quickbuy__sizes');
                    const quickbuySizesWrapper = row.find('.quickbuy__form .select-wrapper');
                    const productVariants = product.variants;
                    if (quickBuySizesContainer && productVariants) {
                        if (productVariants.length > 1) {
                            if (quickbuySizesWrapper) {
                                quickbuySizesWrapper.addClass('show-arrow');
                            }

                            productVariants.forEach(function (v) {
								let newSize =
									'<option value="' +
									v.id +
									'" name="id" data-quantity="1"' +
									(!v.available ? " disabled" : "") +
									">" +
									v.title +
									(!v.available
										? " (" + window.languages.productFormSoldOut.toLowerCase() + ")"
										: "") +
									"</option>";
									
                                quickBuySizesContainer.append(newSize);
                            })
                        } else if (productVariants.length == 1) {
                            let v = productVariants[0];
                            let quickBuySizeTitle = row.find('.quickbuy__sizes-title');
                            quickBuySizeTitle.hide();
                            quickBuySizesContainer.replaceWith('<input type="hidden" value="' + v.id + '" name="id" data-quantity="1">');
                        }
                    }

                    row.find('form').on('submit', function (e) {
                        e.preventDefault();
                        const form = e.target.closest('form');
                        const formErrorsContainer = form.querySelector('.quickbuy__errors-container');
                        let items = [];
                        const formData = {items}, values = {};
                        form.querySelectorAll('input[type="hidden"], select.quickbuy__sizes').forEach((input) => {
                            let name = input.getAttribute('name');
                            let value = parseInt(input.value);
                            values[name] = value;
                        });

                        formData.items[0] = values;
                        const url = window.Shopify.routes.root + 'cart/add.js';
                        fetch(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(formData)
                        })
                            .then(async response => {
                                if (!response.ok) {
                                    await response.json()
                                        .then(res => {
                                            console.log(res.description);
                                            formErrorsContainer.innerHTML = res.description;
                                            formErrorsContainer.style.display = 'block';
                                            console.error(res);
                                            throw res.description;
                                        });
                                }

                                document.dispatchEvent(new CustomEvent('product:added', {
                                    bubbles: true,
                                    detail: {
                                        variant: values["id"],
                                        quantity: values["quantity"]
                                    }
                                }));
                            })
                            .catch((error) => {
                                console.error('Error:', error);
                            });
                    })
                }

                row.find('[data-url]').attr('href', p.du);
                row.find('[data-image]').attr('src', p.iu);
                row.find('[data-price]').html(p.pr + _swat.currency);

                if (p.op) {
                    row.find('[data-original-price]').html(p.op + _swat.currency);
                }

                /*  if(!p.stk) {
                   row.find('[data-add]').addClass('disabled');
                 } */


                row.find('[data-remove]').on('click', function (e) {
                    e.preventDefault();
                    startLoading(row);

                    _swat.removeFromWishList(p, function callback() {
                        row.remove();
                        window.loadWishlistBubble(0);
                        stopLoading(row);
                    });
                    products_remaining--;

                    if (products_remaining < 1) {
                        empty_template.show();
                    }
                });

                $wishlistContainer.append(row);
            });
        });
    }

    generateShareLink = function (sharelink) {
        let lid = null; // List ID you wish to share.

        let onSuccess = (link) => {
            var body = 'Check out some of my favorite things @Manebí.';
            sharelink.find('a').attr('href', 'mailto:?subject=My Wishlist&body=' + body + '%0D%0A%0D%0A' + link);
            document.getElementById("generated-link").value = link;
        }

        let onError = (error) => {
            // Error is an xhrObject
            console.log("Error while generating the link", error)
        }
        _swat.generateSharedListURL(lid, onSuccess, onError);
    }


    wishlistShareLink = function (sharelink) {

        sharelink.on('click', function (e) {
            var copyText = document.getElementById("generated-link");
            copyText.select();
            copyText.setSelectionRange(0, 99999);
            navigator.clipboard.writeText(copyText.value);

            var linkcode = copyText.value.slice(0, 40) + ' ...';
            var parentMessageDesktop = $('.legal-area__content .headerDesktop .SectionHeader');
            var parentMessageMobile = $('.legal-area__menu-mobile > button');
            var messageDesktop = $('<div class="wishlist-share-link __desktop">' + linkcode + '</div>');
            var messageMobile = $('<div class="wishlist-share-link __mobile">' + linkcode + '</div>');
            if ($(parentMessageDesktop).find('.wishlist-share-link').length <= 0) {
                parentMessageDesktop.append(messageDesktop);
            }
            
            if ($('.legal-area__menu-mobile').find('.wishlist-share-link').length <= 0) {
                messageMobile.insertAfter(parentMessageMobile);
            }
        });
    }


})(window, jQuery);

function setMinHeight() {
    var product_tile_list = $('.product-tile__wrapper'),
        fields_list = product_tile_list.find('.product__meta a[data-url] span'),
        minHeight = 1;

    product_tile_list.each(function () {
        var $elHeight = $(this).find('.product__meta a[data-url] span').outerHeight();

        if ($elHeight > minHeight) {
            minHeight = $elHeight;
        }
    });

    fields_list.css('min-height', `${minHeight}px`);
}

if (!window.SwymCallbacks) window.SwymCallbacks = [];


function swymCallbackFn(swat) {
// your API calls go here
    document.addEventListener("swym:collections-loaded", function () {
        swat.initializeActionButtons(".ProductItem__Wrapper");
    })
}

window.SwymCallbacks.push(swymCallbackFn);

window.SwymCallbacks.push(function () {

    window.loadWishlistBubble(0);

    $('#add-to-wishlist').on('click', function (e) {
        e.preventDefault();
        if (SwymPageData) {
            SwymPageData.et = 4;  // et 4 stands for wishlist event type
            _swat.addToWishList(SwymPageData, function (e) {
                $('#add-to-wishlist').addClass('added');
                window.loadWishlistBubble(0);
            });
        }
    });

    window._swat.evtLayer.addEventListener(SwymTracker.JSEvents.addedToWishlist, function (e) {
        window.loadWishlistBubble(1);
    });

    window._swat.evtLayer.addEventListener(SwymTracker.JSEvents.removedFromWishlist, function (e) {
        window.loadWishlistBubble(0);
    });
});


window.loadWishlistBubble = function (prevProduct) {

    _swat.fetchWrtEventTypeET(function (products) {
        $('.wishlist__bubble').html(products.length + prevProduct);
        if ((products.length + prevProduct) > 0) {
            $('.wishlist__bubble').addClass('wishlist__bubble--visible');
        } else {
            $('.wishlist__bubble').removeClass('wishlist__bubble--visible');
        }

    }, _swat.EventTypes.addToWishlist);
}

